var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMatchStart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    x: 3.28,
    y: 6.39,
    width: 3.81,
    height: 37.22,
    rx: 1.91,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42.91,
    y: 6.39,
    width: 3.81,
    height: 37.22,
    rx: 1.91,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "7.09 10.94 38.34 10.94 42.91 10.94",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "7.09 25.84 38.34 25.84 42.56 25.84",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7,18.18a6.4,6.4,0,0,0-1.41-.43,8.59,8.59,0,0,1-.86-.26.85.85,0,0,1-.36-.2.32.32,0,0,1-.07-.22.31.31,0,0,1,.15-.3,1.35,1.35,0,0,1,1.19,0,.52.52,0,0,1,.25.34.64.64,0,0,0,.24.25.68.68,0,0,0,.29.06h1.07a.46.46,0,0,0,.34-.14.49.49,0,0,0,.13-.33,1.58,1.58,0,0,0-.22-.73,2.47,2.47,0,0,0-.56-.67,2.94,2.94,0,0,0-.91-.5,3.86,3.86,0,0,0-1.22-.18,3.76,3.76,0,0,0-1.48.27,2.31,2.31,0,0,0-1,.79,1.92,1.92,0,0,0-.37,1.17,1.89,1.89,0,0,0,1.16,1.83,5.4,5.4,0,0,0,1.27.42c.38.09.7.18.93.26a1.38,1.38,0,0,1,.44.22.26.26,0,0,1,.08.21.38.38,0,0,1-.19.33,1.58,1.58,0,0,1-.79.16,1.68,1.68,0,0,1-.55-.08.83.83,0,0,1-.31-.2.57.57,0,0,1-.16-.23l0-.06a1,1,0,0,0-.17-.18.56.56,0,0,0-.35-.1h-1a.45.45,0,0,0-.46.47,1.85,1.85,0,0,0,.38,1.06,2.47,2.47,0,0,0,1.05.79,4.15,4.15,0,0,0,1.64.29A4.34,4.34,0,0,0,14.36,22a2.58,2.58,0,0,0,1.1-.79A2,2,0,0,0,15.88,20a1.9,1.9,0,0,0-.3-1.1A2.05,2.05,0,0,0,14.7,18.18Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.68,16.68a.45.45,0,0,0,.15-.34v-.87a.51.51,0,0,0-.5-.5h-5a.48.48,0,0,0-.34.14.49.49,0,0,0-.15.36v.87a.51.51,0,0,0,.49.49h1.49V21.7a.48.48,0,0,0,.5.5h1.06a.48.48,0,0,0,.5-.5V16.83h1.48A.45.45,0,0,0,21.68,16.68Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.68,15.42a.67.67,0,0,0-.19-.31.64.64,0,0,0-.42-.14H23.85a.64.64,0,0,0-.42.14.61.61,0,0,0-.18.29L21,21.59a.77.77,0,0,0,0,.15.4.4,0,0,0,.13.31.41.41,0,0,0,.33.15h1a.53.53,0,0,0,.39-.14.48.48,0,0,0,.15-.22l.35-.9h2.34l.34.89a.65.65,0,0,0,.15.23.57.57,0,0,0,.4.14h1a.45.45,0,0,0,.33-.14.48.48,0,0,0,.13-.32.62.62,0,0,0,0-.18Zm-.61,3.76H23.84l.62-1.72Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33,19.35a2,2,0,0,0,.74-.66,2.19,2.19,0,0,0,.39-1.32,2.18,2.18,0,0,0-.79-1.79,3.25,3.25,0,0,0-2-.61H28.78a.48.48,0,0,0-.5.5V21.7a.51.51,0,0,0,.14.36.52.52,0,0,0,.36.14h1a.51.51,0,0,0,.36-.14.48.48,0,0,0,.15-.36V19.75h.74l1.09,2.05a.79.79,0,0,0,.17.23.57.57,0,0,0,.44.17h1.07a.46.46,0,0,0,.46-.46.6.6,0,0,0-.06-.24Zm-1-2a.61.61,0,0,1-.17.48.88.88,0,0,1-.6.17h-1V16.69h1a.81.81,0,0,1,.6.18A.62.62,0,0,1,32.06,17.36Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M40.12,15.12a.49.49,0,0,0-.36-.15h-5a.48.48,0,0,0-.35.14.52.52,0,0,0-.14.36v.87a.48.48,0,0,0,.14.34.45.45,0,0,0,.35.15h1.48V21.7a.51.51,0,0,0,.14.36.52.52,0,0,0,.36.14h1.07a.48.48,0,0,0,.35-.14.48.48,0,0,0,.15-.36V16.83h1.47a.49.49,0,0,0,.36-.15.48.48,0,0,0,.14-.34v-.87A.48.48,0,0,0,40.12,15.12Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMatchStart);
export default __webpack_public_path__ + "static/media/MATCH_START.894faa84fd8db699a3730376c14b561e.svg";
export { ForwardRef as ReactComponent };